var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "salesSettings", attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        [
          _c(
            "v-btn",
            {
              attrs: { disabled: _vm.getDataLoading, color: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleDepartment(false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("addDepartment")) + "\n    ")]
          ),
          _vm._v(" "),
          _vm.isMod
            ? [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary" },
                    on: { click: _vm.cancelEdit }
                  },
                  [_vm._v(_vm._s(_vm.$t("cancel")) + " ")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { loading: _vm.saveLoading, color: "primary" },
                    on: { click: _vm.submit }
                  },
                  [_vm._v(_vm._s(_vm.$t("save")) + "\n      ")]
                )
              ]
            : _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: !_vm.departments.length || _vm.getDataLoading
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleDepartment(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("editDepartment")) + "\n    ")]
              ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md2: "", xs4: "" } },
            [
              _c("v-select", {
                staticStyle: { paddingTop: "0" },
                attrs: {
                  items: _vm.departments,
                  label: _vm.$t("departmentFilter"),
                  "item-text": "name",
                  "item-value": "name",
                  clearable: ""
                },
                model: {
                  value: _vm.departmentFilter,
                  callback: function($$v) {
                    _vm.departmentFilter = $$v
                  },
                  expression: "departmentFilter"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-form",
        { ref: "form" },
        [
          _c("v-data-table", {
            attrs: { headers: _vm.headers, items: _vm.tableData },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function(props) {
                  return [
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      [
                        !_vm.isMod
                          ? [_vm._v(_vm._s(props.item.name))]
                          : _c("v-text-field", {
                              attrs: {
                                clearable: "",
                                rules: [_vm.fieldIsRequired()],
                                required: ""
                              },
                              model: {
                                value: props.item.name,
                                callback: function($$v) {
                                  _vm.$set(props.item, "name", $$v)
                                },
                                expression: "props.item.name"
                              }
                            })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      [
                        !_vm.isMod
                          ? [_vm._v(_vm._s(props.item.leaderName))]
                          : _c("v-text-field", {
                              attrs: {
                                clearable: "",
                                rules: [_vm.fieldIsRequired()],
                                required: ""
                              },
                              model: {
                                value: props.item.leaderName,
                                callback: function($$v) {
                                  _vm.$set(
                                    props.item,
                                    "leaderName",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "props.item.leaderName"
                              }
                            })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      [
                        !_vm.isMod
                          ? _vm._l(props.item.managers || [], function(tag) {
                              return _c("v-chip", { key: tag }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(tag) +
                                    "\n            "
                                )
                              ])
                            })
                          : _c("v-combobox", {
                              attrs: {
                                label: _vm.$t("enterToAddManager"),
                                required: "",
                                "hide-selected": "",
                                multiple: "",
                                "persistent-hint": "",
                                "small-chips": ""
                              },
                              model: {
                                value: props.item.managers,
                                callback: function($$v) {
                                  _vm.$set(props.item, "managers", $$v)
                                },
                                expression: "props.item.managers"
                              }
                            })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.isMod
                      ? _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            _c(
                              "v-layout",
                              { attrs: { "justify-center": "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "primary",
                                      flat: "",
                                      icon: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteDepartment(props.index)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "lighten-2" } },
                                      [_vm._v("delete")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af1f3c62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af1f3c62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SalesSettings.vue
// module id = null
// module chunks = 